import ProtectedRoute from 'components/ProtectedRoute'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useFlag from 'hooks/useFlag'
import React from 'react'
import { Redirect, Switch } from 'react-router'
import CreateEdit from './CreateEdit'
import Detail from './Detail'
import Landing from './Landing'
import OloPlaceholder from './OloPlaceholder'

const PromoCodes = () => {
  const promoCodesEnabled = useFlag('mx-universal-promo-codes', false)
  const overviewEnabled = useFlag('mx-promo-codes-overview', false)
  const merchant = useCurrentMerchant()

  if (!promoCodesEnabled) {
    return <Redirect to="/" />
  }

  // Loading guard: useCurrentMerchant returns null until the Redux store is
  // hydrated from the API. Without this, Olo merchants would render Landing
  // (and any data fetches it kicks off) for one frame before re-rendering as
  // OloPlaceholder.
  if (!merchant) {
    return null
  }

  // Strict false check: the field arrives only after nexus#186 ships, so
  // undefined must fall through to Landing. !merchant?.olo_promotions_enabled
  // would route every Olo merchant to the placeholder until then — including
  // dev/sandbox where the LD flag is on today.
  // The Overview landing page absorbs the placeholder as its "Olo Config" tab,
  // so Olo merchants get the full page once that flag is on.
  const showOloPlaceholder =
    !overviewEnabled &&
    merchant.ordering_provider === 'olo' &&
    merchant.olo_promotions_enabled === false

  if (showOloPlaceholder) {
    return (
      <Switch>
        <ProtectedRoute
          redirect="/"
          resource="Promotions"
          exact
          path="/promo_codes"
          component={OloPlaceholder}
        />
      </Switch>
    )
  }

  return (
    <Switch>
      <ProtectedRoute
        redirect="/"
        resource="Promotions"
        exact
        path="/promo_codes"
        component={Landing}
      />
      <ProtectedRoute
        redirect="/"
        resource="Promotions"
        exact
        path="/promo_codes/new"
        component={CreateEdit}
      />
      <ProtectedRoute
        redirect="/"
        resource="Promotions"
        exact
        path="/promo_codes/:id/edit"
        component={CreateEdit}
      />
      <ProtectedRoute
        redirect="/"
        resource="Promotions"
        exact
        path="/promo_codes/:id"
        component={Detail}
      />
    </Switch>
  )
}

export default PromoCodes
